var map = {
	"./MenuMainDashboard/index.js": 2230,
	"./MenuPerson/index.js": 2231
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2229;


//////////////////
// WEBPACK FOOTER
// ./src/static/menus \.\/.+\/index\.js$
// module id = 2229
// module chunks = 1